import { axisBottom, curveMonotoneX, line, ScaleContinuousNumeric, ScaleTime, select } from 'd3'
import { useMemo } from 'react'
import styled from 'styled-components/macro'

import { PriceHistoryPoint } from './types'

const HistoryPath = styled.path<{ $stroke?: string }>`
  fill: none;
  stroke: ${({ $stroke, theme }) => $stroke ?? theme.textPrimary};
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-width: 2;
`

const StyledAxis = styled.g`
  line,
  .domain {
    display: none;
  }

  text {
    color: ${({ theme }) => theme.textSecondary};
    font-size: 10px;
  }
`

export function PriceHistory({
  points,
  xScale,
  yScale,
  stroke,
  clipPath,
}: {
  points: PriceHistoryPoint[]
  xScale: ScaleTime<number, number>
  yScale: ScaleContinuousNumeric<number, number>
  stroke?: string
  clipPath?: string
}) {
  const path = useMemo(
    () =>
      line<PriceHistoryPoint>()
        .curve(curveMonotoneX)
        .x((point) => xScale(point.timestamp))
        .y((point) => yScale(point.price))(points) ?? undefined,
    [points, xScale, yScale]
  )

  return <HistoryPath d={path} $stroke={stroke} clipPath={clipPath} />
}

export function PriceHistoryAxis({ xScale, innerHeight }: { xScale: ScaleTime<number, number>; innerHeight: number }) {
  const axisRef = (axis: SVGGElement) => {
    axis && select(axis).call(axisBottom(xScale).ticks(4).tickSize(0).tickPadding(8))
  }

  return <StyledAxis ref={axisRef} transform={`translate(0, ${innerHeight})`} />
}
